import { api } from '..';

export function getExhibitions(payload) {
  return api('GET', `/panel/exhibitions`, payload);
}

export function addExhibition(payload) {
  return api('POST', '/panel/exhibitions', payload);
}

export function recoverExhibition(payload) {
  return api('PATCH', `/panel/exhibitions/${payload.id}/recover`,payload, {lang:payload.lang});
}

export function editExhibition(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  return api('PATCH', `/panel/exhibitions/${payload.id}`, payload);
}

export function checkExhibitionsAlias(payload) {
  return api('GET', `/panel/exhibitions/alias/check`, payload);
}

export function getExhibitionByLang(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  payload.lang = payload.lang || 'default';
  return api(
    'GET',
    `/panel/exhibitions/${payload.id}/default`,
    payload
  );
}

export function setExhibitionByLang(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  payload.lang = payload.lang || 'default';
  return api(
    'PATCH',
    `/panel/exhibitions/${payload.id}/${payload.lang}`,
    payload,
    {lang:payload.lang}
  );
}

export function publishExhibition(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  payload.lang = payload.lang || 'default';
  return api('POST', `/panel/exhibitions/${payload.id}/publish`, payload);
}

export function addKeyVision(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  payload.lang = payload.lang || 'default';
  return api(
    'POST',
    `/panel/exhibitions/${payload.id}/${payload.lang}/assets/keyVision`,
    payload
  );
}

export function addKeyVision3D(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  payload.lang = payload.lang || 'default';
  return api(
    'POST',
    `/panel/exhibitions/${payload.id}/${payload.lang}/assets/keyVision3D`,
    payload
  );
}

export function addStaticArtwork(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  payload.lang = payload.lang || 'default';
  return api(
    'POST',
    `/panel/exhibitions/${payload.id}/${payload.lang}/assets/staticArtwork`,
    payload
  );
}

export function addVideoArtwork(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  payload.lang = payload.lang || 'default';
  return api(
    'POST',
    `/panel/exhibitions/${payload.id}/${payload.lang}/assets/videoArtwork`,
    payload
  );
}

export function addMusicArtwork(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  payload.lang = payload.lang || 'default';
  return api(
    'POST',
    `/panel/exhibitions/${payload.id}/${payload.lang}/assets/musicArtwork`,
    payload
  );
}

export function addWebsiteArtwork(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  payload.lang = payload.lang || 'default';
  return api(
    'POST',
    `/panel/exhibitions/${payload.id}/${payload.lang}/assets/websiteArtwork`,
    payload
  );
}

export function addWallVision(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  payload.lang = payload.lang || 'default';
  return api(
    'POST',
    `/panel/exhibitions/${payload.id}/${payload.lang}/assets/wallVision`,
    payload
  );
}

export function addModelArtwork(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  payload.lang = payload.lang || 'default';
  return api(
    'POST',
    `/panel/exhibitions/${payload.id}/${payload.lang}/assets/modelArtwork`,
    payload
  );
}

export function deleteAsset(payload) {
  if (!payload.id) {
    return { error: new Error(`field 'id' is required`) };
  }
  payload.lang = payload.lang || 'default';
  return api(
    'DELETE',
    `/panel/exhibitions/${payload.id}/${payload.lang}/assets/${payload.index}`,
    payload
  );
}
